(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["color-tone-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalize = (value) => (value || '').trim().toLowerCase();

    const initPicker = (picker) => {
      if (picker.dataset.colorTonePickerReady === 'true') return;

      const dataElement = picker.querySelector('[data-color-tone-data]');
      const wrapper = picker.closest('.variant-wrapper');
      const fieldset = wrapper && wrapper.querySelector('.variant-input-wrap');
      const trigger = picker.querySelector('.color-tone-picker__trigger');
      const panel = picker.querySelector('.color-tone-picker__panel');
      const closeButton = picker.querySelector('.color-tone-picker__close');
      const search = picker.querySelector('input[type="search"]');
      const groupsElement = picker.querySelector('.color-tone-picker__groups');
      const colorsElement = picker.querySelector('.color-tone-picker__colors');
      const emptyElement = picker.querySelector('.color-tone-picker__empty');

      if (!dataElement || !fieldset || !trigger || !panel || !closeButton || !search || !groupsElement || !colorsElement || !emptyElement) return;

      let groups;
      try {
        groups = JSON.parse(dataElement.textContent);
      } catch (error) {
        return;
      }

      const getInput = (name) => Array.from(fieldset.querySelectorAll('.variant-input')).find((item) => item.dataset.value === name)?.querySelector('input');
      const availableGroups = groups.map((group) => ({
        ...group,
        children: group.children.filter((color) => getInput(color.name))
      })).filter((group) => group.children.length);

      const nativeColorCount = fieldset.querySelectorAll('input[type="radio"]').length;
      const mappedColorCount = availableGroups.reduce((count, group) => count + group.children.length, 0);

      if (!availableGroups.length) {
        picker.hidden = true;
        return;
      }

      picker.dataset.colorTonePickerReady = 'true';
      picker.dataset.colorTonePickerComplete = String(mappedColorCount === nativeColorCount);
      let activeGroup = availableGroups.find((group) => group.children.some((color) => normalize(color.name) === normalize(picker.dataset.selectedColor))) || availableGroups[0];

      const setSwatch = (element, code, image) => {
        element.style.setProperty('--color-tone-code', code || 'transparent');
        element.style.setProperty('--color-tone-image', image ? `url("${image}")` : 'none');
      };

      const updateSelected = () => {
        const selectedInput = fieldset.querySelector('input:checked');
        if (!selectedInput) return;
        const selectedColor = availableGroups.flatMap((group) => group.children).find((color) => normalize(color.name) === normalize(selectedInput.value));
        picker.dataset.selectedColor = selectedInput.value;
        picker.querySelector('.color-tone-picker__selected').textContent = selectedInput.value;
        setSwatch(picker.querySelector('.color-tone-picker__swatch'), selectedColor && selectedColor.code);
        activeGroup = availableGroups.find((group) => group.children.some((color) => normalize(color.name) === normalize(selectedInput.value))) || activeGroup;
      };

      const renderGroups = (query) => {
        groupsElement.innerHTML = '';
        availableGroups.forEach((group) => {
          const hasMatch = group.children.some((color) => normalize(`${group.name} ${color.name}`).includes(query));
          if (query && !hasMatch) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'color-tone-picker__group';
          button.setAttribute('role', 'tab');
          const isSelected = group.name === activeGroup.name;
          button.setAttribute('aria-selected', String(isSelected));
          button.classList.toggle('is-selected', isSelected);
          button.innerHTML = '<span class="color-tone-picker__group-swatch" aria-hidden="true"></span><span></span>';
          setSwatch(button.querySelector('.color-tone-picker__group-swatch'), group.code, group.imgUrl);
          button.querySelector('span:last-child').textContent = group.name;
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            activeGroup = group;
            search.value = '';
            render();
          });
          groupsElement.appendChild(button);
        });
      };

      const renderColors = (query) => {
        colorsElement.innerHTML = '';
        const colors = query
          ? availableGroups.flatMap((group) => group.children.map((color) => ({...color, groupName: group.name}))).filter((color) => normalize(`${color.groupName} ${color.name}`).includes(query))
          : activeGroup.children;

        colors.forEach((color) => {
          const input = getInput(color.name);
          if (!input) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'color-tone-picker__item';
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', String(input.checked));
          button.disabled = input.classList.contains('disabled') || input.disabled;
          button.innerHTML = '<span class="color-tone-picker__item-swatch" aria-hidden="true"></span><span></span>';
          setSwatch(button.querySelector('.color-tone-picker__item-swatch'), color.code, color.imgUrl);
          button.querySelector('span:last-child').textContent = color.name;
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (button.disabled) return;
            input.click();
            updateSelected();
            render();
            close();
          });
          colorsElement.appendChild(button);
        });

        const hasColors = colorsElement.children.length > 0;
        colorsElement.hidden = !hasColors;
        emptyElement.hidden = hasColors;
        emptyElement.textContent = picker.dataset.noResults;
      };

      const render = () => {
        const query = normalize(search.value);
        renderGroups(query);
        renderColors(query);
      };

      const close = () => {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          close();
          return;
        }
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        render();
        search.focus();
      });

      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        close();
        trigger.focus();
      });

      search.addEventListener('input', render);
      fieldset.addEventListener('change', () => {
        updateSelected();
        render();
      });
      document.addEventListener('click', (event) => {
        if (!picker.contains(event.target)) close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });

      updateSelected();
      render();
    };

    const initAllPickers = () => document.querySelectorAll('[data-color-tone-picker]').forEach(initPicker);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPickers);
    } else {
      initAllPickers();
    }

    document.addEventListener('shopify:section:load', initAllPickers);
  })();
  } catch(e) { console.error(e); }
})();

})();
